import { StyledSkeleton } from "components/StyledSkeleton/StyledSkeleton";

export function EventTeeTimesSkeleton() {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <StyledSkeleton
        data-skeleton-name="You’re playing!"
        style={{
          top: 91.6875,
          left: 24.453125,
          width: 216.06689453125,
          height: 30.140625,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Rectangle 2"
        style={{ top: 220, left: 24, width: "90%", height: 131 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 276.2744140625,
          left: 45.216796875,
          width: 187.3388671875,
          height: 13.330078125,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 263.705078125,
          left: 284.6943359375,
          width: 60.5673828125,
          height: 10.4248046875,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 240.576171875,
          left: 265.9794921875,
          width: 78.4287109375,
          height: 14.755859375,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 18"
        style={{ top: 236, left: 44, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 22"
        style={{ top: 236, left: 74, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 20"
        style={{ top: 236, left: 104, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 21"
        style={{ top: 236, left: 134, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 243.08203125,
          left: 166.755859375,
          width: 24.25830078125,
          height: 11.056640625,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 316.333984375,
          left: 289.11767578125,
          width: 50.0869140625,
          height: 8.876953125,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Rectangle 2"
        style={{ top: 363, left: 24, width: "90%", height: 131 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 419.2744140625,
          left: 44.4853515625,
          width: 161.75146484375,
          height: 50.8759765625,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 406.705078125,
          left: 284.6943359375,
          width: 60.5673828125,
          height: 10.4248046875,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 383.908203125,
          left: 265.9599609375,
          width: 78.4482421875,
          height: 14.423828125,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 18"
        style={{ top: 379, left: 44, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 22"
        style={{ top: 379, left: 74, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 20"
        style={{ top: 379, left: 104, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 21"
        style={{ top: 379, left: 134, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 386.544921875,
          left: 167.025390625,
          width: 28.60888671875,
          height: 8.671875,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 459.544921875,
          left: 300.15869140625,
          width: 28.1337890625,
          height: 8.666015625,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Image Placeholder 2"
        style={{ top: 19, left: 26, width: 50, height: 50 }}
      />
      <StyledSkeleton
        data-skeleton-name="Mike Stashak"
        style={{
          top: 44.5390625,
          left: 91.3671875,
          width: 103.654296875,
          height: 12.75,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 141.568359375,
          left: 26.791015625,
          width: 206.4716796875,
          height: 42.142578125,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Rectangle 2"
        style={{ top: 506, left: 24, width: "90%", height: 131 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 601.2744140625,
          left: 45.216796875,
          width: 189.46875,
          height: 13.3505859375,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 549.705078125,
          left: 284.6943359375,
          width: 60.5673828125,
          height: 10.4248046875,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 526.576171875,
          left: 263.9287109375,
          width: 80.4794921875,
          height: 14.755859375,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 18"
        style={{ top: 522, left: 44, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 22"
        style={{ top: 522, left: 74, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 20"
        style={{ top: 522, left: 104, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Ellipse 21"
        style={{ top: 522, left: 134, width: 24, height: 24 }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 529.08203125,
          left: 166.75,
          width: 24.75634765625,
          height: 11.056640625,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="Description"
        style={{
          top: 602.333984375,
          left: 300.13525390625,
          width: 27.1435546875,
          height: 8.876953125,
        }}
      />
      {/* <StyledSkeleton
        data-skeleton-name="Rectangle 115"
        style={{ top: 0, left: 0, width: "100%", height: 725 }}
      /> */}
    </div>
  );
}
